import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import Button from 'accordium-react-ui-toolkit/crater/component/Button/Button';
import ErrorPage from '../ErrorPage';
import styles from '../ErrorPage/ErrorPage.module.scss';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '', errorInfo: {}, openModal: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log('[getDerivedStateFromError] error: ', error);

    return { hasError: true };
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // Route has been changed. Clear the errors
      this.setState({ hasError: false, error: '', errorInfo: {}, openModal: false });
    }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('[componentDidCatch] error: ', error);
    console.log('[componentDidCatch] errorInfo: ', errorInfo);
    this.setState({ error: error?.toString(), errorInfo });
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    const { children } = this.props;
    const { hasError, error, errorInfo, openModal } = this.state;
    if (hasError) {
      return (
        <>
          <ErrorPage
            errorTitle="It’s not you. It’s us."
            errorMessage={
              <div className={styles.content}>
                <div className={styles.firstLine}>
                  <span>We all thought computers would never make mistakes,</span>
                </div>
                <div>and then this happens.</div>
              </div>
            }
            action={
              <Button kind="danger" small onClick={() => this.setState({ openModal: true })}>
                Show Error
              </Button>
            }
            httpStatus="000"
          />
          <Modal open={openModal} onClose={() => this.setState({ openModal: false })} center closeIconSize={16}>
            {error}
            <br />
            <br />
            <br />
            {JSON.stringify(errorInfo)}
          </Modal>
        </>
      );
    }

    return children;
  }
}

export default withRouter(GlobalErrorBoundary);
